import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
const FlipkartIcon: React.FC<IconProps> = ({ size, style, color }) => {
  const colorId = color ?? '#f7e830';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={size ?? '20'} height={size ?? '20'} viewBox="0 0 20 20" data-testid="flipkart-icon">
      <defs>
        <linearGradient
          id={`ava${colorId}`}
          x1={356.481}
          x2={356.481}
          y1={493.134}
          y2={1080.898}
          gradientTransform="translate(.14 -373.546)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: color ?? '#f7e830',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: color ?? '#fdcb06',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient
          id={`cav${colorId}`}
          x1={520.03}
          x2={520.197}
          y1={514.347}
          y2={542.18}
          gradientTransform="translate(.14 -373.546)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: color ?? '#fada1c',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: color ?? '#fdcb06',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient
          id={`dil${colorId}`}
          x1={-811.13}
          x2={-810.963}
          y1={513.013}
          y2={540.846}
          gradientTransform="matrix(-1 0 0 1 -618.343 -373.546)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: color ?? '#fada1c',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: color ?? '#fdcb06',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <clipPath id={`effe${colorId}`}>
          <path d="M5 3h10v5H5Zm0 0" />
        </clipPath>
        <clipPath id={`fum${colorId}`}>
          <path d="M14.586 4.152a.277.277 0 0 1-.027-.136l-.024.004c-.031-.118-.137-.23-.27-.239-.1-.008-.226-.004-.285.086-.113.145-.058.332-.066.496 0 .012.004.028.004.04 0 .109-.016.218-.035.324a.258.258 0 0 0-.024.105 2.363 2.363 0 0 1-.273.73.339.339 0 0 0-.055.106c-.082.14-.183.27-.285.398-.02.012-.031.028-.047.043-.074.086-.152.16-.234.235-.02.011-.031.023-.047.035a1.75 1.75 0 0 1-.32.238l-.043.031c-.72.454-1.59.641-2.438.649a4.705 4.705 0 0 1-2.097-.422c-.012-.008-.04-.016-.051-.023-.11-.055-.223-.106-.324-.172-.02-.012-.043-.028-.07-.035a2.973 2.973 0 0 1-.294-.2.917.917 0 0 0-.097-.074 2.575 2.575 0 0 1-.36-.32 2.664 2.664 0 0 1-.668-1.078c-.12-.32-.105-.668-.12-1.004-.098-.149-.313-.23-.481-.14-.07.046-.078.136-.133.198-.086.887.308 1.77.941 2.41 0 .02.008.036.032.043.109.098.218.2.332.297.02.02.043.04.066.055.113.086.234.168.352.25.023.02.043.031.07.043.152.086.3.191.465.25l.043.027a5.18 5.18 0 0 0 1.695.461c.062 0 .129.008.191.02.282.015.563.008.844.004.863-.074 1.758-.274 2.485-.762l.007.008c.02-.016.043-.031.063-.051.117-.078.226-.164.34-.254a.609.609 0 0 0 .078-.062c.125-.13.265-.25.37-.399l.017.012a.682.682 0 0 1 .03-.055c.098-.125.184-.254.266-.383l.028-.027-.012-.012c.008-.011.027-.03.035-.043.156-.3.293-.617.34-.949.02-.008.031-.023.031-.043.004-.105.043-.21.031-.316a1.95 1.95 0 0 0 .024-.399Zm0 0" />
        </clipPath>
        <radialGradient
          id={`bio${colorId}`}
          cx={353.416}
          cy={761.212}
          r={478.08}
          fx={353.416}
          fy={761.212}
          gradientTransform="translate(.14 -373.546)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0.596}
            style={{
              stopColor: color ?? '#f29405',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={0.736}
            style={{
              stopColor: color ?? '#f7d01e',
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: color ?? '#fdcb06',
              stopOpacity: 1,
            }}
          />
        </radialGradient>
      </defs>
      <path
        d="M712.84 122.602c-.28-1.018-.558-2.036-.976-3.054-236.872.146-473.744 0-710.477.146-.558.727-.976 1.454-1.115 2.327 0 183.685 0 367.225-.14 550.91 1.533 9.89 6.967 18.762 14.074 25.452.418.145 1.114.145 1.393.29 3.623 3.928 8.918 5.818 13.934 7.564 3.762-.146 7.385 1.454 11.007 1.018h294c2.787 0 5.713.436 8.36-.728.14-.29.28-1.018.419-1.454 0-.436.139-1.6.278-2.182 6.27-35.195 12.401-70.536 19.09-105.731l.557-4.509h-81.651c-6.689-.29-13.377 0-20.065-.873-11.286-.436-22.712-.145-33.998-1.163-13.934 0-27.867-1.309-41.801-1.309-11.008-1.163-22.155-.727-33.301-1.163-7.107-1.018-14.491-.582-21.876-.873-11.844-1.309-23.966-.436-35.95-1.745-12.54.145-25.08-.873-37.76-1.164.14-.145.28-.581.28-.727 4.18.146 8.22-.145 12.4-.29 9.336-1.164 18.81-.292 28.007-1.6 9.753 0 19.368-1.31 28.982-1.31 8.639-1.308 17.417-.581 25.917-1.745 10.171 0 20.064-1.309 30.096-1.454 8.36-1.018 16.72-.436 25.08-1.6 9.615.146 19.23-1.309 28.983-1.309 9.475-1.018 19.228-.727 28.703-1.745-.975-3.636-1.672-7.417-2.369-11.053-.696-2.327-3.483-1.89-5.294-2.182-21.737-3.054-43.334-6.108-64.931-9.162 1.393-1.164 3.205-.582 4.877-.727 16.86-1.31 33.44-2.91 50.3-4.073 3.762-.145 7.524-.872 11.286-1.018-1.672-5.235-2.647-10.907-5.016-15.707-35.81-5.526-71.758-10.326-107.568-16.288 9.336-1.455 18.672-2.182 28.007-3.2l.836-.29c29.679-3.055 59.497-6.546 89.176-9.454 37.62-.291 75.241-.146 113.001 0 1.115-.291 3.345.29 3.484-1.31 3.065-16.288 6.13-32.431 9.196-48.575 4.32-22.542 11.147-44.794 21.597-65.3 16.442-33.014 42.637-60.938 74.406-79.554 29.679-17.452 64.095-25.742 98.232-27.342 11.147-1.018 22.294-.727 33.302.582 7.245 1.745 14.63 3.781 20.343 8.726 4.737 3.781 7.524 9.308 9.614 14.98 4.598 13.235 7.246 27.051 9.336 41.013.139 5.526 1.114 11.78-1.812 16.87-2.786 5.09-8.36 7.418-13.655 9.017-19.367 4.945-39.571.291-58.8 4.945-16.023 3.345-30.793 12.217-40.825 24.87-11.983 14.834-18.253 33.305-21.737 51.63-2.647 16.434-6.13 32.868-8.778 49.302 18.95.146 38.039-.145 57.128.146 7.663 0 15.466 4.217 18.532 11.344 4.04 9.162 3.065 19.634 1.811 29.378-1.533 10.907-4.18 21.67-9.057 31.705-4.18 8.435-11.007 16.289-20.204 19.197-4.876 1.891-10.032 1.6-15.187 1.6-16.72 0-33.58.146-50.3 0-2.788 12.217-4.599 24.87-6.968 37.377-4.319 24.288-8.638 48.721-13.097 73.009-.14.873-.14 2.618-.14 3.49 7.803.291 15.745 0 23.688.146 58.521 0 117.321-.146 175.982 0 6.27.145 12.68-1.31 18.253-4.363 3.205-1.164 5.295-4.072 8.081-5.672 2.787-1.6 3.623-4.945 5.992-6.981 2.647-4.654 5.295-9.454 5.573-14.835.279 0 1.115-.145 1.533-.29-.279-183.977 0-367.953-.279-551.93Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: `url(#ava${colorId})`,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#fcd109',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M93.488 1.6c8.5-2.763 17.417-.873 26.056-1.455h489.908c9.753-.436 18.253 5.09 27.17 7.854 7.246 2.909 14.77 5.236 22.015 8.29 1.394.582 2.508 1.89 3.623 3.054-.14 13.09 0 26.47 0 39.704.14 3.49-.557 7.126.697 10.471 2.09.437 3.205 2.036 4.598 3.2 6.549 3.054 12.262 7.999 18.253 11.926 8.918 6.399 18.532 12.07 27.31 18.615.418 2.618.14 5.382-.697 7.709-.836 2.763-.278 5.817-.557 8.58-236.872.146-473.744 0-710.477.146-.558-3.345.418-6.545-.976-9.744-.278-2.618-1.114-5.963 1.394-7.709 10.032-6.98 20.621-13.38 30.375-20.797a556.375 556.375 0 0 0 17.835-11.926c1.254-1.89.836-4.363.836-6.69 0-14.398 0-28.941.14-43.485 3.344-4.363 9.335-4.8 13.933-6.981C74.538 8.726 84.014 5.236 93.488 1.6m.558 1.745L55.589 17.743c-1.672.291-2.648 1.89-3.484 3.2 0 .727.14 2.181.14 2.908-.14 12.072 0 23.997-.14 36.069.14 2.908-.278 5.962.836 8.726a21.109 21.109 0 0 1-4.32 3.49C34.132 81.59 20.198 91.77 5.707 101.078c-2.508 1.454-5.295 3.49-4.598 6.835-.418 1.746.418 3.345 2.369 2.764 31.35-.146 62.701.145 94.052-.291 46.678 0 93.355.145 140.033 0l.697-.291c2.09.436 4.18.29 6.41.29 84.577 0 169.154.146 253.87 0 26.614.146 53.367 0 79.98 0 44.03 0 88.2.437 132.091.146 1.393-.29 1.811-1.163 1.254-2.763-.14-1.6.557-3.781-1.254-4.8-6.967-3.344-12.958-8.435-19.646-12.361-2.37-2.037-5.435-3.055-7.246-5.818-6.967-3.927-13.376-8.726-20.204-12.944-1.254-.872-2.23-2.181-3.344-3.2a27.5 27.5 0 0 0 .836-6.69c-.14-12.652 0-25.305-.14-38.104.28-1.89.14-4.217-1.532-5.526-12.122-4.363-23.966-8.872-35.81-13.38-3.761-1.745-7.802-2.763-11.843-3.345H100.594c-2.23.145-4.32 1.163-6.548 1.745Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ?? '#f8f3b5',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#f8f3b5',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M52.245 23.851c8.778 3.782 18.253 5.818 27.17 9.454 4.738 1.89 6.27 7.126 8.36 11.344-2.09 2.036-4.598 3.781-7.106 5.38-9.196 6.11-18.532 12.218-27.728 18.617-1.114-2.764-.696-5.818-.836-8.726.14-12.072 0-23.997.14-36.069Zm581.59 9.454c8.779-3.49 18.114-5.963 27.032-9.454.14 12.799 0 25.452.14 38.105a27.5 27.5 0 0 1-.837 6.69c-7.803-5.527-15.745-10.617-23.548-15.853-3.762-2.763-7.942-4.945-11.286-8.29 2.09-4.217 3.623-9.308 8.5-11.198Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ?? '#f7b402',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#f7b402',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M204.818 37.377c11.008-2.618 23.409 7.272 22.433 18.761.14 11.199-11.843 20.507-22.712 17.889-4.319-1.6-8.638-3.781-11.286-7.708-3.483-5.381-4.32-12.362-1.533-18.18 2.09-5.672 7.385-9.453 13.098-10.762Zm285.361 6.254c4.599-5.09 11.844-8 18.672-6.109 5.155 1.455 10.171 4.8 12.261 9.745 4.459 8.58 1.115 20.215-7.524 24.724-7.664 4.217-17.278 2.181-22.99-3.927-5.992-6.69-6.27-17.743-.419-24.433Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ?? '#bda727',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#bda727',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M80.67 50.03c2.507-1.6 5.015-3.345 7.105-5.381l.697.582c.697 5.235.14 10.616.418 15.707-.279 15.707.279 31.414-.418 46.975-29.121 0-58.243-.29-87.364 0-.697-3.345 2.09-5.38 4.598-6.835C20.197 91.77 34.131 81.59 48.622 72.136a21.109 21.109 0 0 0 4.32-3.49c9.195-6.4 18.531-12.508 27.727-18.616Zm543.551-2.036c0-1.31.418-2.473 1.115-3.49 3.344 3.344 7.524 5.526 11.286 8.29 7.803 5.235 15.745 10.325 23.548 15.852 1.115 1.018 2.09 2.327 3.344 3.2 6.828 4.217 13.237 9.016 20.204 12.943 1.811 2.763 4.877 3.781 7.246 5.818 6.688 3.926 12.68 9.017 19.646 12.362 1.811 1.018 1.115 3.2 1.254 4.799-29.121.145-58.103-.145-87.225.145-.418-4.072-.14-7.999-.278-11.925 0-15.998-.14-31.996-.14-47.994Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ?? '#f7e62d',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#f7e62d',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M711.864 107.768c-29.121.145-58.103-.145-87.225.145-.418-4.072-.14-7.999-.278-11.925 0-15.998-.14-31.996-.14-47.994 0-1.31.418-2.473 1.115-3.49 2.09-4.218 3.623-9.309 8.5-11.2 8.778-3.49 18.113-5.962 27.03-9.453.28-1.89.14-4.217-1.532-5.526-12.122-4.363-23.966-8.872-35.81-13.38-3.761-1.745-7.802-2.763-11.843-3.345H100.594c-2.23.145-4.32 1.163-6.548 1.745L55.589 17.743c-1.672.291-2.648 1.89-3.484 3.2 0 .727.14 2.181.14 2.908 8.778 3.782 18.253 5.818 27.17 9.454 4.738 1.89 6.27 7.126 8.36 11.344l.697.582c.697 5.235.14 10.616.418 15.707-.279 15.707.279 31.414-.418 46.975-29.121 0-58.243-.29-87.364 0-.418 1.746.418 3.345 2.369 2.764 31.35-.146 62.701.145 94.052-.291 46.678 0 93.355.145 140.033 0l.697-.291c2.09.436 4.18.29 6.41.29 84.577 0 169.154.146 253.87 0 26.614.146 53.367 0 79.98 0 44.03 0 88.2.437 132.091.146 1.393-.29 1.811-1.163 1.254-2.763ZM191.72 48.139c2.09-5.672 7.385-9.453 13.098-10.762 11.008-2.618 23.409 7.272 22.433 18.761.14 11.199-11.843 20.507-22.712 17.889-4.319-1.6-8.638-3.781-11.286-7.708-3.483-5.381-4.32-12.362-1.533-18.18Zm298.46-4.508c4.598-5.09 11.843-8 18.67-6.109 5.156 1.455 10.172 4.8 12.262 9.745 4.459 8.58 1.115 20.215-7.524 24.724-7.664 4.217-17.278 2.181-22.99-3.927-5.992-6.69-6.27-17.743-.419-24.433Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: `url(#bio${colorId})`,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#fcd109',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M515.678 151.69c1.393.29-7.245-8.29-5.573-8.727 1.532.146 7.663-4.508 14.909-.581 7.384 3.781 5.573 12.798 4.737 16.143-.975 3.927-3.483 6.4-5.573 8.435-1.115.873-3.484 2.327-5.017 2.182.836-4.8-1.95-5.672-2.229-10.617Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: `url(#cav${colorId})`,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#fcd109',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M196.04 157.216c-.279 4.945-3.205 5.672-2.23 10.617-1.532.145-4.04-1.309-5.155-2.182-1.95-2.036-4.459-4.508-5.434-8.435-.836-3.345-2.647-12.362 4.737-16.289 7.246-3.781 13.377.873 14.91.728 1.671.436-6.967 9.017-5.574 8.726Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: `url(#dil${colorId})`,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#fcd109',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M502.58 215.827c1.533-1.31 2.508-1.31 4.46-1.31-11.984 26.034-25.917 51.921-46.957 72.137-2.369 2.036-4.738 3.927-7.246 5.672-2.368 1.745-4.737 3.345-7.106 5.09-2.23 1.6-4.598 3.2-6.827 4.8-5.574 3.2-10.59 7.417-17 9.308-11.425 5.526-23.826 9.307-36.366 11.925-4.877.728-9.893 1.891-14.91 2.036-6.13 1.746-12.818.437-19.088.873-3.484.582-6.55-1.309-10.033-1.018-2.926-.436-5.852-.873-8.778-1.454-2.926-.582-5.852-1.31-8.778-2.036-45.842-14.399-90.848-49.303-103.945-96.715-.697-3.2-.976-6.4-.976-9.6 1.394 2.764 2.927 5.528 4.46 8.29 18.531 40.577 55.595 72.573 99.346 82.317 3.484 1.6 7.385 1.019 10.73 2.473 3.065 0 6.13-.146 9.056.873 10.31.145 20.622.145 30.933.145 1.393 0 2.647-.727 4.18-1.018 17.138-.582 33.859-5.236 49.604-12.362 3.065-1.31 6.27-2.909 9.196-4.509 2.647-1.309 5.295-2.908 7.803-4.508s4.877-3.345 7.245-5.09c18.532-14.69 34.556-33.742 45.424-55.557 1.95-3.927 3.901-7.563 5.573-10.762Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ?? '#bda727',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ?? '#bda727',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M486.278 304.688c29.679-17.452 64.095-25.742 98.232-27.342 11.147-1.018 22.294-.727 33.302.582 7.245 1.745 14.63 3.781 20.343 8.726-2.926.146-5.713-1.163-8.639-1.6-8.081-1.6-16.581-1.018-24.941-1.163-24.105 0-48.35 1.89-71.759 8.435-12.122 3.781-24.383 7.999-35.391 14.398-19.228 10.617-36.506 24.724-50.58 41.45-24.94 28.65-39.71 65.155-46.816 102.24-3.344 19.926-7.246 39.705-10.311 59.63-5.016.581-10.172.29-15.188.29l-65.906-.436c-4.738.146-9.336-.873-14.073-.582-39.99.146-79.98-.145-119.969-.145l.836-.29c29.679-3.055 59.497-6.546 89.176-9.454 37.62-.291 75.241-.146 113.001 0 1.115-.291 3.345.29 3.484-1.31 3.065-16.288 6.13-32.431 9.196-48.575 4.32-22.542 11.147-44.794 21.597-65.3 16.442-33.014 42.637-60.938 74.406-79.554Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ? 'transparent' : '#0d69b3',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: '#0d69b3',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M532.816 292.326c23.409-6.545 47.654-8.435 71.759-8.435 8.36.145 16.86-.437 24.941 1.163 2.926.437 5.713 1.746 8.639 1.6 4.737 3.781 7.524 9.308 9.614 14.98 4.598 13.235 7.246 27.051 9.336 41.013.139 5.526 1.114 11.78-1.812 16.87-2.786 5.09-8.36 7.418-13.655 9.017-19.367 4.945-39.571.291-58.8 4.945-16.023 3.345-30.793 12.217-40.825 24.87-11.983 14.834-18.253 33.305-21.737 51.63-2.647 16.434-6.13 32.868-8.778 49.302-1.254 3.782-1.95 7.708-2.647 11.635 18.95.291 37.76 0 56.71.146 7.245-.146 14.351.29 21.597-.291 4.04 9.162 3.065 19.634 1.811 29.378-1.533 10.907-4.18 21.67-9.057 31.705-4.18 8.435-11.007 16.289-20.204 19.197-4.876 1.891-10.032 1.6-15.187 1.6-16.72 0-33.58.146-50.3 0-2.788 12.217-4.599 24.87-6.968 37.377-4.319 24.288-8.638 48.721-13.097 73.009-.14.873-.14 2.618-.14 3.49-43.751 0-87.364.146-131.115 0 .139-.29.278-1.018.418-1.454 0-.436.139-1.6.278-2.182.14.728.14 2.327.279 3.055 2.647.29 7.664 1.6 8.36-2.327 6.688-36.796 13.098-73.736 20.065-110.532-2.787-.581-5.574-.581-8.36-.145-.419 1.454-.837 2.909-1.255 4.218l.558-4.509h-81.651c-6.689-.29-13.377 0-20.065-.873-11.286-.436-22.712-.145-33.998-1.163-13.934 0-27.867-1.309-41.801-1.309-11.008-1.163-22.155-.727-33.301-1.163-7.107-1.018-14.491-.582-21.876-.873-11.844-1.309-23.966-.436-35.95-1.745-12.54.145-25.08-.873-37.76-1.164.14-.145.28-.581.28-.727 4.18.146 8.22-.145 12.4-.29 9.336-1.164 18.81-.292 28.007-1.6 9.753 0 19.368-1.31 28.982-1.31 8.639-1.308 17.417-.581 25.917-1.745 10.171 0 20.064-1.309 30.096-1.454 8.36-1.018 16.72-.436 25.08-1.6 9.615.146 19.23-1.309 28.983-1.309 9.475-1.018 19.228-.727 28.703-1.745-.975-3.636-1.672-7.417-2.369-11.053-.696-2.327-3.483-1.89-5.294-2.182-21.737-3.054-43.334-6.108-64.931-9.162 1.393-1.164 3.205-.582 4.877-.727 16.86-1.31 33.44-2.91 50.3-4.073 3.762-.145 7.524-.872 11.286-1.018-1.672-5.235-2.647-10.907-5.016-15.707-35.81-5.526-71.758-10.326-107.568-16.288 9.336-1.455 18.672-2.182 28.007-3.2 39.99 0 79.98.29 119.969.145 4.737-.29 9.335.728 14.073.582l65.906.436c5.016 0 10.172.291 15.188-.29 3.065-19.925 6.967-39.704 10.31-59.63 7.107-37.085 21.877-73.59 46.818-102.24 14.073-16.726 31.35-30.833 50.579-41.45 11.008-6.399 23.27-10.617 35.391-14.398Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ? 'transparent' : '#107bd4',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ? 'transparent' : '#107bd4',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M511.498 499.281c18.95.146 38.039-.145 57.128.146 7.663 0 15.466 4.217 18.532 11.344-7.246.581-14.352.145-21.597.29-18.95-.145-37.76.146-56.71-.145.696-3.927 1.393-7.853 2.647-11.635Zm-147.557 93.661c2.786-.436 5.573-.436 8.36.145-6.967 36.796-13.377 73.736-20.065 110.532-.696 3.926-5.713 2.618-8.36 2.327-.14-.728-.14-2.327-.279-3.055 6.27-35.195 12.401-70.536 19.09-105.731.417-1.31.835-2.764 1.254-4.218Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: color ? 'transparent' : '#0d69b3',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: color ? 'transparent' : '#0d69b3',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <path
        d="M520.276 154.598c-.836-1.6-.975-3.345-.975-5.09l-.836.145c-1.115-4.363-4.877-8.58-9.614-8.871-3.623-.291-8.082-.146-10.172 3.2-4.04 5.38-2.09 12.362-2.369 18.47 0 .436.14 1.018.14 1.454 0 4.072-.558 8.145-1.254 12.071-.558 1.31-.836 2.618-.836 3.927-1.672 9.453-5.156 18.761-9.754 27.197-.836 1.163-1.533 2.472-1.95 3.926-2.927 5.236-6.55 10.036-10.172 14.835-.697.436-1.115 1.018-1.672 1.6-2.648 3.2-5.434 5.963-8.36 8.726-.697.436-1.115.872-1.673 1.309-3.483 3.345-7.245 6.399-11.425 8.871-.418.291-.976.728-1.533 1.164-25.638 16.87-56.71 23.851-86.946 24.142-25.777.873-51.694-4.654-74.824-15.707-.418-.29-1.393-.582-1.811-.873-3.901-2.036-7.942-3.926-11.565-6.399-.697-.436-1.533-1.018-2.508-1.309-3.623-2.327-7.106-4.654-10.45-7.417a32.9 32.9 0 0 0-3.484-2.763c-3.622-2.909-7.245-5.963-10.45-9.453a19.458 19.458 0 0 0-2.369-2.473c-10.868-11.344-19.367-25.16-23.826-40.14-4.32-11.926-3.762-24.87-4.32-37.377-3.483-5.527-11.147-8.58-17.138-5.236-2.508 1.745-2.787 5.09-4.737 7.417-3.066 33.014 11.007 65.883 33.58 89.734 0 .727.278 1.31 1.114 1.6 3.902 3.636 7.803 7.417 11.844 11.053a16.208 16.208 0 0 0 2.369 2.036c4.04 3.2 8.36 6.254 12.54 9.308a9.273 9.273 0 0 0 2.508 1.6c5.434 3.2 10.729 7.126 16.581 9.308.418.29 1.115.727 1.533 1.018 18.95 9.017 39.432 15.27 60.472 17.161 2.23 0 4.598.291 6.827.728 10.033.581 20.065.29 30.097.145 30.793-2.763 62.702-10.18 88.618-28.36l.279.29c.696-.58 1.532-1.163 2.23-1.89 4.18-2.909 8.08-6.108 12.121-9.453.976-.727 1.951-1.454 2.787-2.327 4.459-4.8 9.475-9.308 13.237-14.835l.558.437c.278-.582.836-1.6 1.114-2.036 3.484-4.654 6.549-9.454 9.475-14.253l.975-1.018-.418-.436c.28-.437.976-1.164 1.254-1.6 5.574-11.199 10.45-22.98 12.123-35.341.696-.291 1.114-.873 1.114-1.6.14-3.927 1.533-7.853 1.115-11.78.836-4.945.976-9.89.836-14.835Zm0 0"
        style={{
          fillRule: 'nonzero',
          fill: '#fff',
          fillOpacity: 1,
          strokeWidth: 0.094,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          stroke: '#fff',
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="matrix(.02803 0 0 .02686 0 0)"
      />
      <g clipPath={`url(#effe${colorId})`}>
        <g clipPath={`url(#fum${colorId})`}>
          <path
            d="M185.729 151.108c8.082 2.618 26.753-3.781 32.047 2.036m-27.31 22.688c7.664-2.763 24.384-9.163 31.212-5.381m-23.27 30.105c3.763 1.164 11.148-5.381 14.77-7.417 5.574-2.909 11.147-5.09 17.278-5.963m-20.064 39.268c3.901-5.381 8.5-10.035 14.073-13.962 5.573-3.782 20.76-14.253 27.31-10.617m-30.097 43.34c4.459-3.49 6.27-9.744 10.868-13.38 5.574-4.509 14.073-5.236 19.786-8m-11.704 35.196c1.254-9.744 11.007-21.379 20.482-20.506m-5.991 34.032c4.876-.582 9.056-11.635 12.4-15.416 5.017-5.527 10.311-7.272 16.86-9.308m-.696 36.65c-.28-6.981 6.966-27.052 15.327-26.033M305 291.163c-.279-8.29 4.04-33.16 14.073-34.032m7.942 47.412c-1.811-11.635-1.672-28.36 7.385-36.796m20.065 39.414c-1.115-9.6-10.59-29.088 0-36.65m29.26 29.96c-4.598-5.236-7.245-26.179-5.294-31.996m33.301 27.342c-3.483-6.4-7.942-12.363-9.196-19.78-.836-4.508.557-10.907-.14-14.252m32.605 23.996c-7.524-4.944-9.753-23.415-7.245-31.268m29.957 21.379c-5.434-11.78-11.147-20.798-11.286-34.032m33.301 12.653c-8.5-5.672-19.228-15.998-17.974-27.342m41.383 9.308c-12.959-2.909-28.286-14.398-36.088-24.724m46.677 2.763c-9.196-2.036-39.85-13.962-38.039-26.033m48.072 2.618c-12.959-4.654-31.77-8.872-42.08-17.889m48.768-3.345c-8.221.582-19.786-3.345-28.146-4.654-9.196-1.6-17.696-4.8-26.614-6.69m46.678-9.308c-15.605.873-30.375-4.508-44.587-9.453"
            style={{
              fill: 'none',
              strokeWidth: 2,
              strokeLinecap: 'butt',
              strokeLinejoin: 'miter',
              stroke: '#d1d1d1',
              strokeOpacity: 1,
              strokeMiterlimit: 4,
            }}
            transform="matrix(.02803 0 0 .02686 0 0)"
          />
        </g>
      </g>
    </svg>
  );
};
export default FlipkartIcon;
